import { Component, Input, OnInit , ViewChild  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HuntingDistrict, NetworkConstants } from 'diwimamodelweb/lib';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { contextIdsFromRights } from '../context-rights-picker/context-rights-picker.component';
import { ContextAccess, isGeoLocked, isReadOnly, resolveContextAccess } from '../context-rights-picker/context-access';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { HuntingDistrictService } from '../hunting-district.service';
import { HuntingDistrictForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';
import { buildCustomDiff } from 'diwimamodelweb/lib/utils/obejct-diff';
import { MatDialog } from '@angular/material/dialog';
import { SignaturePadDialogComponent } from '../signature-pad-dialog/signature-pad-dialog.component';
import { SettingsService } from '../settings.service';
import { skipWhile, take } from 'rxjs/operators';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { ListItem } from '../model/list';
import { TemporalService } from '../temporal.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-hunting-district-form',
  templateUrl: './hunting-district-form.component.html',
  styleUrls: ['./hunting-district-form.component.css', '../../app.component.scss']
})
export class HuntingDistrictFormComponent implements OnInit {

  @Input() data: HuntingDistrictForm
  @Input() formBuilder: FormBuilder
  @Input() userFeedbackService: UserFeedbackService
  @Input() translateService: TranslateService
  @Input() objectService: HuntingDistrictService
  @Input() router: Router
  @Input() route: ActivatedRoute

  districtForm: FormGroup
  oldHuntingDistrict: HuntingDistrict
  isCreate = false
  isNewDistrict = false
  state_Niedersachsen = false
  hiTieractiveValue=false
  title = 'Signature Pad by Rajesh Gami';
  signPad: any;
  listItems$: BehaviorSubject<ListItem[]|undefined> = new BehaviorSubject(undefined)

  @ViewChild('signPadCanvas', {static: false}) signaturePadElement:any;

  allVetAuthorities:any[] = [
    {
      Adress1 : "",
      BNR : "",
      city : "",
      email : " ",
      name : "",
      nuts : "",
      phone : "",
      postcode : "",
      shortName : "",
      state : "",
      url : "",
      sdv : ""
    }
  ]
  allHuntAuthorities:any = []
  changeSignature = false
  savedSignature = false
  isSignature=false
  signImage:any;
  format="png"
  base64ImageData: any
  newDistrictSignature:string
  newSignature:string

  allUsersList:any = []
  allUsersListId:any = {}
  allCountries = []
  allStates = []
  allStatesFiltered = []
  hi_tier:any
  nvTrichinella:any

  previousUrl: string | undefined
  previousUrl$: BehaviorSubject<string> = new BehaviorSubject(undefined)
  currentUrl: string | undefined
  contextAccess: ContextAccess = 'owner'

  get isViewOnly(): boolean { return isReadOnly(this.contextAccess) }
  get isGeoLocked(): boolean { return isGeoLocked(this.contextAccess) }

  hdCreateRight = false
  hdUpdateRight = false
  hdDeleteRight = false

  get hasCrudRight(): boolean {
    return this.isCreate ? this.hdCreateRight : this.hdUpdateRight
  }

  get canSave(): boolean {
    return !this.isViewOnly && this.hasCrudRight && !this.districtForm?.invalid
  }

  /** Deleting a shared district would remove it for the owning context too. */
  get canDelete(): boolean {
    return this.contextAccess === 'owner' && this.hdDeleteRight && !this.districtForm?.invalid
  }

  private loadCrudRights(contextId: string): void {
    const rights = this.settingsService.rightsPercontext
      ?.get(contextId)?.[NetworkConstants.COLLECTION_HUNTING_DISTRICT]
    this.hdCreateRight = !!rights?.['C']
    this.hdUpdateRight = !!rights?.['U']
    this.hdDeleteRight = !!rights?.['D']
  }

  constructor(public dialog: MatDialog,
    private settingsService: SettingsService,
    private userService : UserService,
    public huntingDistrictService: HuntingDistrictService,
    private tempService: TemporalService
  ) { }

  async ngOnInit(): Promise<void> {

    this.districtForm = this.formBuilder.group({
      name: [, Validators.required],
      administrativeName: [],
      state: [],
      stateCode: [],
      county: [],
      country:[],
      countryCode: ['DE'],
      veterinarianOffice:[],
      veterinarianOfficeId:[ , Validators.required],
      huntingOffice: [],
      huntingOfficeId:[, Validators.required],
      // game origin form data
      erlegungsOrt: [],
      jabName: [],
      jabAddress: [],
      jabTelephone: [],
	    jabEmail: [],
      jabFirstName: [],
      jabPostCode: [],
      jabCity: [],
      jabSignature: [],
      gsName: [],
      gsAdresse: [],
      gsTel: [],
      gsFax: [],
      gsEmail: [],
      //extra data
      hitBNR: [],
      hitMBN: [],
      hitPIN: [],
      hitREVAGS: [],
      hiTierActive: [false],
      huntingTenant:[],
      feeDebtor:[],
      templateId:[],
      createdByUserId:[],
      createdByUserName:[],
      nvTrichinellaActive:[],
      contextIdRights: [{}]
    })

    this.districtForm.get('contextIdRights')?.valueChanges.subscribe((rights: any) => {
      if (!this.data?.data) return
      const ids = contextIdsFromRights(rights)
      ;(this.data.data as any).contextIdRights = ids.length ? rights : undefined
      ;(this.data.data as any).contextIds      = ids.length ? ids : undefined
    })

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe( skipWhile(el => !el), take(1) ))
    this.loadCrudRights(context?.identifier)
    this.hi_tier = context.modulesMap?.get('hi-tier') ? true : false
    this.nvTrichinella = context.modulesMap?.get('nvTrichinella') ? true : false

    this.allUsersList = this.huntingDistrictService.allUsers$.value
    if(this.allUsersList?.length==0 || this.huntingDistrictService.allUsers$.value?.length==0 || !this.allUsersList)
      this.huntingDistrictService.getUsersyList(this.settingsService.selectedUserContext$.value.identifier, 'User')
    
    this.huntingDistrictService.allUsers$.subscribe(value => {
      this.allUsersList = value
      value?.forEach(element => {
        const data  = { 
          userId : element.identifier,
          userName: element.displayName
        }
        this.allUsersListId[element.identifier] = data
      });
    })

    //--------------veterinarian Authorities
    this.allVetAuthorities = Object.values(this.huntingDistrictService.allVetAuthoritiesById)
    if(this.allVetAuthorities)
      this.allVetAuthorities.sort((a,b) => a?.shortName?.localeCompare(b.shortName));
    else
      this.huntingDistrictService.getVeterinaryAuthorityList()//.then( values => this.allVetAuthorities = values)
    
    this.huntingDistrictService.allAuthoritiesVeterinary$.subscribe(value => {
      this.allVetAuthorities = value
      if(value && value.length!=0)
      this.allVetAuthorities.sort((a,b) => a?.name?.localeCompare(b?.name));
    })

    //--------------countries
    this.allCountries = this.huntingDistrictService.allCountries$.value ? Object.values(this.huntingDistrictService.allCountries$.value) : undefined
    if(this.allCountries)
      this.allCountries.sort((a,b) => a?.name?.localeCompare(b.name));
    else
      this.huntingDistrictService.getCountriesList()

    this.huntingDistrictService.allCountries$.subscribe(value => {
      this.allCountries = value
      if(value){
        this.allCountries.sort((a,b) => a?.name?.localeCompare(b.name));
        this.setStateOptions(this.districtForm.value.countryCode ? this.districtForm.value.countryCode : 'DE')// Deutschland default
      }
    })

    //--------------states
    this.allStates = this.huntingDistrictService.allStates$.value ? Object.values(this.huntingDistrictService.allStates$.value) : undefined
    if(this.allStates){
      this.allStates.sort((a,b) => a?.name?.localeCompare(b.name));
      this.setStateOptions(this.districtForm.value.countryCode ? this.districtForm.value.countryCode : 'DE')// Deutschland default
    }else
      this.huntingDistrictService.getStatesList()

    this.huntingDistrictService.allStates$.subscribe(value => {
      this.allStates = value
      // if(value && value.length!=0){
        this.allStates?.sort((a,b) => a?.name?.localeCompare(b.name));
        this.setStateOptions(this.districtForm.value.countryCode ? this.districtForm.value.countryCode : 'DE')// Deutschland default
      // }
    })

    //--------------hunting Authorities
    this.allHuntAuthorities = Object.values(this.huntingDistrictService.allHuntAuthoritiesById)
    if(this.allHuntAuthorities)
      this.allHuntAuthorities.sort((a,b) => a?.shortName?.localeCompare(b.shortName));
    else
      this.huntingDistrictService.getHuntingAuthorityList()
    
    this.huntingDistrictService.allAuthoritiesHunting$.subscribe(value => {
      this.allHuntAuthorities = value
      if(value)
      this.allHuntAuthorities.sort((a,b) => a?.shortName?.localeCompare(b.shortName));
    })

    //--------------
    this.districtForm.get('state')?.valueChanges.subscribe((value) => {
      this.state_Niedersachsen = value === "DE-NI" || value === "de-ni" || value === "Niedersachsen"
    })

    this.districtForm.get('countryCode').valueChanges.subscribe( value => {
      const country = this.allCountries?.find( c => c.isoCode === value)
      if(country)
        this.districtForm.patchValue({country: country.name})
    })

    this.districtForm.get('stateCode').valueChanges.subscribe( value => {
      const state = this.allStates?.find( c => c.isoCode === value)
      if(state)
        this.districtForm.patchValue({state: state.name})
    })

    this.districtForm?.valueChanges.subscribe((value) => {
      if (!this.isCreate) {
        const { erlegungsOrt, hitBNR,hitMBN, hitPIN, hitREVAGS, hiTierActive, feeDebtor,huntingTenant  } = value
        let anyObj = {...value}
        delete anyObj.contextIdRights
        delete anyObj.contextIds

        if(erlegungsOrt){
          anyObj.gameOriginData = {
            // gsFax,jabAddress, jabName,jabTelephone, jabSignature,jabEmail,gsName,gsAdresse,gsTel,gsEmail,jabFirstName,abCity,jabPostCode
            erlegungsOrt,
          }
        }
          
        // anyObj.extra = { hitBNR, hitMBN, hitPIN, hitREVAGS }
        if(hitBNR || hitMBN || hitPIN || hitREVAGS){
          anyObj.extra = {}
          if (hitBNR)
            anyObj.extra.hitBNR = hitBNR
          if (hitMBN)
            anyObj.extra.hitMBN = hitMBN
          if (hitPIN)
            anyObj.extra.hitPIN = hitPIN
          if (hitREVAGS)
            anyObj.extra.hitREVAGS = hitREVAGS
        }

        if (huntingTenant){
          const data = this.allUsersListId[huntingTenant]
          anyObj.huntingTenant = data
        }
    
        if (feeDebtor){
          const data = this.allUsersListId[feeDebtor]
          anyObj.feeDebtor = data
        }

        if(hiTierActive!=undefined){
          if(hiTierActive==true){
            this.hiTieractiveValue=true
            anyObj.hiTierActive= true
          }else{
            this.hiTieractiveValue=false
            anyObj.hiTierActive= false
          }
        }else{
          this.hiTieractiveValue=false
          anyObj.hiTierActive= false
        }
        anyObj.hiTierActive= hiTierActive
        this.data.data.setFromAny(anyObj)
      }else{
	      if(value.hiTierActive!=undefined){
          if(value.hiTierActive==true){
            this.hiTieractiveValue=true
          }else{
            this.hiTieractiveValue=false
          }
        }else{
          this.hiTieractiveValue=false
        }
	    }
   
    })
    this.data.onNavBack = this.onCancle  
    const user = await this.userService.user$.pipe(take(1)).toPromise()
    
    if(this.data.data) {
      this.oldHuntingDistrict = deepCopy(this.data.data, this.data.data.replacerFn)
      if(this.data.data.hiTierActive){
		    if(this.data.data.hiTierActive==true)
          this.hiTieractiveValue=true
        else
          this.hiTieractiveValue=false
      }

      this.isNewDistrict=false
      this.initializeWithData()
      const subIds = this.settingsService.getSubcontextIds()// ?? (context as any)?.subContextIds

      this.contextAccess = resolveContextAccess(
        this.data.data as any,
        context?.identifier,
        subIds,
      )
      if (this.isViewOnly) this.districtForm.disable({ emitEvent: false })
    }else{
      this.isCreate = true
      this.hiTieractiveValue=false
      const createdByUserName = user.displayName
      const createdByUserId = user.identifier
      this.districtForm.patchValue({createdByUserName, createdByUserId})
    }
 
  }

 checkPreviousRoute(previousUrl){
    const context = this.settingsService.selectedUserContext$.value

    if(previousUrl === `/cockpit/${context.identifier}/objects/HuntingDistrict/${this.data.data.identifier}/polygon`){
      const { huntingDistrictId, huntingDistrictForm } = this.tempService.getData(HuntingDistrictFormComponent, this.districtForm.value, this.data.data.identifier)

      if(huntingDistrictId == this.data.data.identifier){
        this.districtForm.patchValue(huntingDistrictForm)
        this.tempService.clearData(HuntingDistrictFormComponent)
      }
    }
  }

  initializeWithData() {
    const {name, administrativeName,  state, stateCode, county, countryCode, country, veterinarianOffice, veterinarianOfficeId, huntingOffice,
      huntingOfficeId, gameOriginData, extra, hiTierActive, huntingTenant, feeDebtor,
      templateId, createdByUserId, createdByUserName, nvTrichinellaActive, mandatorySampleTypes} = this.data.data
    
    this.setStateOptions( countryCode ? countryCode : 'DE')

    this.districtForm.patchValue({
      name: name ? name :undefined, 
      administrativeName: administrativeName ? administrativeName : undefined, 
      state: state ? state : undefined, 
      stateCode: stateCode ? stateCode : undefined,
      county: county ? county : undefined,
      country: country ? country : undefined,
      countryCode: countryCode ? countryCode : 'DE',
      veterinarianOffice: veterinarianOffice ? veterinarianOffice : undefined, 
      veterinarianOfficeId: veterinarianOfficeId ? veterinarianOfficeId : undefined, 
      huntingOffice: huntingOffice ? huntingOffice : undefined,
      huntingOfficeId: huntingOfficeId ? huntingOfficeId : undefined,
      gsFax: gameOriginData?.gsFax ? gameOriginData?.gsFax : undefined,
      jabAddress: gameOriginData?.jabAddress ? gameOriginData?.jabAddress : undefined,
      jabName: gameOriginData?.jabName ? gameOriginData?.jabName : undefined,
      jabTelephone: gameOriginData?.jabTelephone ? gameOriginData?.jabTelephone : undefined,
      jabSignature: gameOriginData?.jabSignature ? gameOriginData?.jabSignature : undefined,
      jabEmail: gameOriginData?.jabEmail ? gameOriginData?.jabEmail : undefined,
      jabFirstName: gameOriginData?.jabFirstName ? gameOriginData?.jabFirstName : undefined,
      jabCity:gameOriginData?.jabCity ? gameOriginData?.jabCity : undefined,
      jabPostCode:gameOriginData?.jabPostCode ? gameOriginData?.jabPostCode : undefined,
      gsName: gameOriginData?.gsName ? gameOriginData?.gsName : undefined,
      erlegungsOrt: gameOriginData?.erlegungsOrt ? gameOriginData?.erlegungsOrt : undefined,
      gsAdresse: gameOriginData?.gsAdresse ? gameOriginData?.gsAdresse : undefined,
      gsTel: gameOriginData?.gsTel ? gameOriginData?.gsTel : undefined,
      gsEmail: gameOriginData?.gsEmail ? gameOriginData?.gsEmail : undefined,
      hitBNR: extra?.hitBNR ?  extra.hitBNR : undefined,
      hitMBN: extra?.hitMBN ? extra.hitMBN : undefined,
      hitPIN: extra?.hitPIN ? extra.hitPIN : undefined,
      hitREVAGS: extra?.hitREVAGS ? extra.hitREVAGS : undefined,
      hiTierActive: hiTierActive ? hiTierActive : false,
      huntingTenant:huntingTenant?.userId ? huntingTenant?.userId : undefined,
      feeDebtor: feeDebtor?.userId ? feeDebtor?.userId : undefined,
      templateId: templateId ? templateId : undefined,
      createdByUserId: createdByUserId ? createdByUserId : undefined,
      createdByUserName: createdByUserName ? createdByUserName : undefined,
      nvTrichinellaActive: nvTrichinellaActive ? nvTrichinellaActive : undefined,
      mandatorySampleTypes: mandatorySampleTypes ? mandatorySampleTypes : undefined,
      contextIdRights: (this.data.data as any)?.contextIdRights ?? {}
    })

    this.checkPreviousRoute(this.tempService.previousUrl)
  }

  async onSubmit() {

    if (!this.canSave) {
      if (this.isViewOnly) {
        const message = this.translateService.instant('view_only')
        this.userFeedbackService.showSnackBar.emit(message)
      } else if (!this.hasCrudRight) {
        const not_create = this.translateService.instant('HD_not_allowed_create')
        const not_edit = this.translateService.instant('HD_not_allowed_edit')
        this.userFeedbackService.showSnackBar.emit(
          this.isCreate ? not_create : not_edit,
        )
      }
      return
    }

    const value = this.districtForm.value

    const { veterinarianOffice, veterinarianOfficeId, erlegungsOrt, createdByUserName, createdByUserId,
      hitBNR, hitMBN, hitPIN, hitREVAGS, hiTierActive } = value

    let { huntingTenant, feeDebtor } = value

      if (huntingTenant) {
        const user = this.allUsersList?.find(u => u.identifier === huntingTenant)
        huntingTenant = user ? { userId: user.identifier, userName: user.displayName } : undefined
      }

      if (feeDebtor) {
        const user = this.allUsersList?.find(u => u.identifier === feeDebtor)
        feeDebtor = user ? { userId: user.identifier, userName: user.displayName } : undefined
      }

    // Check if form is valid first
    if(hiTierActive){

      var foundVet = false
      if(this.districtForm.value.veterinarianOffice){
        this.allVetAuthorities.forEach((elem=>{
          if(elem.name==this.districtForm.value.veterinarianOffice && veterinarianOfficeId == this.districtForm.value.veterinarianOfficeId ){
            foundVet = true 
          }
        }))
      }

      if( !foundVet || !veterinarianOffice || !veterinarianOfficeId ){
        
        this.userFeedbackService.loading.emit(false)
        const title = this.translateService.instant('uncomplete_fields_title')
        const message = this.translateService.instant('complete_fields')

        this.userFeedbackService.showDialog.emit({
          entryComponent: GenericDialogComponent,
          title: title,
          message: message,
        })

        return
      } else {
      }
    }

    if (this.isCreate) {
      
      let gameOriginData: any|undefined = undefined
      if (erlegungsOrt ) {
        gameOriginData = { erlegungsOrt }
      }

      let extra: any|undefined = undefined
      if(hitBNR || hitMBN || hitPIN || hitREVAGS){
        extra = {
          hitBNR,
          hitMBN,
          hitPIN,
          hitREVAGS,
        }
      }

      const newDistrict = {
        name: value.name,
        administrativeName: value.administrativeName,
        state: value.state,
        stateCode: value.stateCode,
        county: value.county,
        country: value.country,
        countryCode: value.countryCode,
        veterinarianOffice: veterinarianOffice,
        veterinarianOfficeId: veterinarianOfficeId,
        huntingOffice: value.huntingOffice,
        huntingOfficeId: value.huntingOfficeId,
        hiTierActive: hiTierActive,
        gameOriginData: gameOriginData,
        extra,
        huntingTenant,
        feeDebtor,
        createdByUserName, 
        createdByUserId
      }
          
      const cleaned = removeUndefined(newDistrict)
      try {
        this.userFeedbackService.loading.emit(true)
        await this.objectService.createDistrict(cleaned) 
        this.userFeedbackService.loading.emit(false)
        const sbSuccessSave = this.translateService.instant('successfully_created')
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onSuccessfullySubmitted()
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error.error.message ? error.error.message : JSON.stringify(error),
          }
        )
      }

    } else {
      
      // this caused wipeout

     /*  if(this.data.data.huntingTenant){
        const data = this.allUsersListId[this.data.data.huntingTenant]
        this.data.data.huntingTenant = data
      }
  
      if(this.data.data.feeDebtor){
        const data = this.allUsersListId[this.data.data.feeDebtor]
        this.data.data.feeDebtor = data
      } */
      const newHuntingDistrict = deepCopy(this.data.data, this.data.data.replacerFn)

      // const cleaned = removeUndefined(newHuntingDistrict)////---remove this to delete feeDebtor.userName && huntingTenant.userName when undefined
      const cleaned = newHuntingDistrict
      try{
          this.userFeedbackService.loading.emit(true)
          await this.objectService.updateHuntingDistrict(this.oldHuntingDistrict, cleaned, hiTierActive)
          const sbSuccessSave = this.translateService.instant('changes_saved')
          this.userFeedbackService.loading.emit(false)
          this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
          this.data.onCancle()
        } catch (error) {
          console.error(error)
          this.userFeedbackService.loading.emit(false)
          this.userFeedbackService.showDialog.emit(
            {
              entryComponent: GenericDialogComponent,
              title: "Error",
              message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
            }
          )
        }
      
    }
    this.tempService.clearData(HuntingDistrictFormComponent)
  }

  onMapClick() {
    if (this.isGeoLocked) {
      this.userFeedbackService.showSnackBar.emit(
        'Die Reviergrenze kann nur im Ursprungskontext geändert werden.',
      )
      return
    }
    this.tempService.setData(HuntingDistrictFormComponent, this.districtForm.value, this.data.data.identifier)
    // route to location
    this.router.navigate(['polygon'], {relativeTo: this.route})
  }

  onCancle = async () => {
    this.tempService.clearData(HuntingDistrictFormComponent)
    
    if (this.oldHuntingDistrict ) {
      const newHuntingDistrict = deepCopy(this.data.data, this.data.data.replacerFn)
      const diff = buildCustomDiff(this.oldHuntingDistrict, newHuntingDistrict)

      const cleanDiff = Object.fromEntries(
        Object.entries(diff).filter(([_, value]) => {
          const val = value as any
          const isOldEmpty = val.oldValue == null;
          const isNewEmpty = val.newValue == null;      
          return !(isOldEmpty && isNewEmpty);
        })
      );

      if (Object.keys(cleanDiff).length == 0) this.data.onCancle()
      else {
        const title = this.translateService.instant('title_unsaved_changes')
        const message = this.translateService.instant('msg_unsaved_changes')
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title,
            message,
            cancleCallback: async () => {
              const sbChangesDismissed = this.translateService.instant('changes_dismissed')
              this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
              this.data.onCancle()
            },
            positiveCallback: async ()=> {
              await this.onSubmit()
              this.data.onSuccessfullySubmitted()
            }
          }
        )
      }
    } else {
      const title = this.translateService.instant('title_unsaved_changes')
      const message = this.translateService.instant('msg_unsaved_changes')
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title,
          message,
          cancleCallback: async () => {
            const sbChangesDismissed = this.translateService.instant('changes_dismissed')
            this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
            this.data.onCancle()
          },
          positiveCallback: async ()=> {
            await this.onSubmit()
            this.data.onSuccessfullySubmitted()
          }
        }
      )
    }
  }


  async onDelete(){
    if(!this.canDelete) return
    if(!this.isNewDistrict){
      const title = this.translateService.instant('delete_title')
      const message = this.translateService.instant('delete_message')
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showDialog.emit({
        entryComponent: GenericDialogComponent,
        title,
        message,
        cancleCallback: async ()=>{
          const sbCancelDelete = this.translateService.instant('delete_canceled')
          this.userFeedbackService.showSnackBar.emit(sbCancelDelete)
        },
        positiveCallback: async ()=> {
          try{

            this.userFeedbackService.loading.emit(true)
              const sbSuccessDelete = this.translateService.instant('delete_completed')
              await this.objectService.deleteDistrictHunting(this.data.data)
              this.userFeedbackService.loading.emit(false)
              this.userFeedbackService.showSnackBar.emit(sbSuccessDelete)
              this.data.onCancle()
          }catch(errorDelete){
            console.log(errorDelete)
              const sbErrorDelete = this.translateService.instant('delete_error')
              this.userFeedbackService.showSnackBar.emit(sbErrorDelete)
          }
        }
      })
    }else{
      this.userFeedbackService.loading.emit(true)
      const sbSNoDelete = this.translateService.instant('delete_not_possible') 
      this.userFeedbackService.showSnackBar.emit(sbSNoDelete)  
    }
  }

  setOfficeName(field, vet, id,name){
    this.districtForm.patchValue( {[field]: name})
  }

  setStateOptions(countryId){

    const states = deepCopy(this.allStates)
    if(this.allCountries?.some(country => country.id === countryId))
      this.allStatesFiltered = states?.filter( state => state.countryShortId === countryId)
    else{
      this.districtForm.patchValue({countryCode: 'DE'})
      this.allStatesFiltered = states?.length!= 0 ? states?.filter( state => state.countryShortId === 'de') : states
    }
  }

  // ////////////////
// Signature-pad functions

  openSignaturePad(){
    const dialogRef=this.dialog.open( SignaturePadDialogComponent, {
      data: {
        title:"SiganturePad",
        message:"",
        dataValues: this.data.data,
        className: this.data.className
      }
    })

    dialogRef.afterClosed().subscribe( result => {
      if(result!=undefined){
        if(this.isCreate){
          this.newDistrictSignature=result
          this.districtForm.patchValue({jabSignature: result})
        }else{
          if(!this.data.data.gameOriginData){
            this.districtForm.patchValue({jabSignature: result})
            this.data.data.gameOriginData={
              jabSignature: result,
            }

            this.newSignature=result.toString()
            this.districtForm.patchValue({jabSignature: this.newSignature})

          }else{
            this.data.data.gameOriginData.jabSignature=result
            this.districtForm.patchValue({jabSignature: result})
          }
        }
      }
     
      
    })
  }

}

